import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TimeOffRequestRules } from '@app/models/time-off-v3/time-off-request-rules.model';
import { TimeOffSeniorityOverride } from '@app/models/time-off-v3/time-off-seniority-override.model';
import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { Subscription } from 'rxjs';
import { TimeOffCreateFlowService } from '../../services';
import { AmountAccruedPerYearUpdateCardComponent } from '@time-off-v3/components';

@Component({
    selector: 'app-accrual-schedule-form',
    templateUrl: 'accrual-schedule.template.html',
    styles: [
        `
            form {
                --form-field-label-left-margin: 0;
            }
        `,
    ],
})
export class AccrualScheduleForm extends BaseForm implements OnInit, OnDestroy {
    @ViewChild('amountAccruedPerYearUpdateCardComponent')
    amountAccruedPerYearUpdateCardComponent: AmountAccruedPerYearUpdateCardComponent;
    timeOffPolicy = new TimeOffPolicy();
    timeOffType = new TimeOffType();
    timeOffRequestRules = new TimeOffRequestRules();

    private timeOffPolicySubscription!: Subscription;
    private timeOffTypeSubscription!: Subscription;
    private timeOffRulesSubscription!: Subscription;

    constructor(private timeOffCreateFlowService: TimeOffCreateFlowService) {
        super();
    }

    ngOnInit(): void {
        this.timeOffPolicySubscription = this.timeOffCreateFlowService.timeOffPolicy$.subscribe((policy) => {
            this.timeOffPolicy = policy;
        });

        this.timeOffTypeSubscription = this.timeOffCreateFlowService.timeOffType$.subscribe((type) => {
            this.timeOffType = type;

            this.timeOffRequestRules.timeOffType = type;

            // because this setter tries to convert, it is challenging to maintain the original input
            // while playing around with policy type changing (hours vs days) in the first step of new creation flow
            // as a simple fix, unset the negative balance cap whenever the policy type changes.
            this.timeOffRequestRules.negativeBalanceCap = undefined;

            if (type.displayInHours !== undefined && type.hoursPerDay !== undefined) {
                this.amountAccruedPerYearUpdateCardComponent.onAmountAccruedPerYearChange();
            }
        });

        this.timeOffRulesSubscription = this.timeOffCreateFlowService.timeOffRequestRules$.subscribe((rules) => {
            this.timeOffRequestRules = rules;
        });
    }

    onSeniorityOverrideChange(timeOffSeniorityOverrides: TimeOffSeniorityOverride[]): void {
        this.timeOffCreateFlowService.updateTimeOffSeniorityOverrides(timeOffSeniorityOverrides);
    }

    onUpdate(): void {
        this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
    }

    updateTimeOffRequestRules(timeOffRequestRule: TimeOffRequestRules): void {
        this.timeOffCreateFlowService.updateTimeOffRequestRules(timeOffRequestRule);
    }

    ngOnDestroy(): void {
        this.timeOffPolicySubscription.unsubscribe();
        this.timeOffTypeSubscription.unsubscribe();
        this.timeOffRulesSubscription.unsubscribe();
    }
}
